<template>
    <div class="receive-form-container">
        <receive-result
            :succeedType="receive.result.succeedType"
            :failedType="receive.result.failedType"
            :studentName="receive.result.studentName"
        ></receive-result>

        <van-popup round v-model="receive.studentInfo.displayPopup" style="overflow: unset; overflow-y: auto !important;">
            <select-student
                :studentList="receive.studentInfo.studentList"
                @close="displaySelectStudent = false"
                @confirm="confirmSelectStudent"
            ></select-student>
        </van-popup>

        <div class="header-section" v-html="bannerTextHtml">
            <!-- <p>限时领取2节</p>
            <p>价值<strong>398元</strong>名师体验课</p> -->
        </div>

        <div :class="['input-mobile-section', user.auth.logged ? 'disabled' : '']">
            <div class="input-mobile-prenumber">+86</div>
            <input
                class="input-mobile"
                type="mobile"
                :placeholder="user.info.mobile || '请输入你的手机号码'"
                maxlength="11"
                v-model="user.view.inputmobile"
                :disabled="user.auth.logged"
            />
        </div>

        <div class="input-code-section" v-if="!user.auth.logged">
            <div class="input-code-icon"></div>
            <input class="input-code" placeholder="请输入短信验证码" v-model="user.view.inputcode" />
            <div v-if="user.auth.delay > 0" class="input-code-button disabled">已发送({{ user.auth.delay }}s)</div>
            <div v-else @click="doRequestSmsCode" class="input-code-button">
                {{ user.auth.resendCode ? '重新发送' : '发送验证码' }}
            </div>
        </div>

        <div class="grade-select-section">
            <p class="title">本期活动开放年级</p>
            <div class="flex-box">
                <div
                    v-for="(grade, index) in receive.gradeInfo.gradeList"
                    :key="index"
                    :class="['grade', receive.gradeInfo.selectedGradeIndex === index ? 'selected' : '']"
                    @click="receive.gradeInfo.selectedGradeIndex = index"
                >
                    {{ grade.gradeText }}
                </div>
            </div>
            <p class="grade-tips">其他年级敬请期待哦</p>
        </div>

        <div
            :class="[
                'submit-button',
                (user.view.inputcode && user.view.inputmobile) || (user.auth.logged && user.view.inputmobile) ? 'disabled' : ''
            ]"
            @click="doReceive"
        >
            立即免费领取
        </div>
    </div>
</template>

<style lang="scss" scoped>
/deep/ .header-section {
    padding: 24px 0px;
    padding-left: 180px;
    background: url(./img/gift.png) no-repeat;
    background-size: contain;
    font-weight: bolder;
    font-size: 40px;

    p {
        line-height: 48px;
        white-space: nowrap;
    }

    strong {
        color: #ff6422;
    }
}

.input-mobile-section.disabled {
    background: #ddd;
}

.input-mobile-section {
    margin-top: 32px;
    border: 1px solid gainsboro;
    border-radius: 15px;
    font-size: 24px;
    padding: 24px;

    .input-mobile-prenumber {
        display: inline-block;
        vertical-align: middle;
        padding-right: 24px;
        border-right: 1px solid gainsboro;
    }

    .input-mobile {
        padding-left: 24px;
        display: inline-block;
        vertical-align: middle;
        background: transparent;
    }
}

.input-code-section {
    position: relative;
    overflow: hidden;
    margin-top: 24px;
    border: 1px solid gainsboro;
    border-radius: 15px;
    font-size: 24px;

    .input-code {
        display: inline-block;
        vertical-align: middle;
        margin: 24px;
        margin-right: 0px;
    }

    .input-code-button.disabled {
        background: gray;
    }

    .input-code-button {
        position: absolute;
        top: 0px;
        right: 0px;
        color: #fff;
        background: #ff6422;
        padding: 24px;
        height: 100%;
        line-height: 40px;
    }
}

.grade-select-section {
    .title {
        font-size: 24px;
        margin-top: 24px;
        margin-bottom: 24px;
    }

    .flex-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .grade {
        font-size: 24px;
        text-align: center;
        margin-bottom: 24px;
        height: 72px;
        line-height: 72px;
        border-radius: 10px;
        width: calc(50% - 12px);
        border: 2px solid gainsboro;
    }

    .selected {
        background: #fff3ee;
        color: #ff6422;
        border: 4px solid #ff6422;
        line-height: 68px;
    }

    .grade-tips {
        font-size: 24px;
        text-align: center;
        opacity: 0.5;
        margin-top: 12px;
        margin-bottom: 24px;
    }
}

.submit-button {
    font-weight: bolder;
    font-size: 32px;
    text-align: center;
    color: #fff;
    width: 100%;
    padding: 32px 0px;
    background: #ff6422;
    border-radius: 50px;
}
</style>

<script>
import { Toast } from 'vant'

import SelectStudent from '@/components/actouch/select-student/index.vue'
import ReceiveResult from './receive-result.vue'

import commonController from './controller/common.js'
import userController from './controller/user.js'
import receiveController from './controller/receive.js'

import GradeManage from './model/GradeManage.js'
import Customization from './model/Customization.js'

export default {
    mixins: [commonController, userController, receiveController],
    components: {
        SelectStudent,
        ReceiveResult
    },
    data () {
        return {
            /** 应用信息 */
            appId: 80001,
            channelId: '',
            highChannelId: '',
            activityCode: '',
            channelKeyword: '',
            bannerTextHtml: ''
        }
    },
    async created () {
        Toast.loading()

        const customId = this.$route.query.customId
        if (!customId) {
            this.receive.result.failedType = 2
        }

        try {
            this.receive.gradeInfo.gradeList = (await GradeManage.getList()).slice(0, 8).sort((a, b) => a.grade - b.grade)
            let customize = await Customization.get(customId)
            this.channelId = customize.channelId
            this.highChannelId = customize.highChannelId
            this.activityCode = customize.activityCode
            this.bannerTextHtml = (() => {
                let result = '<p>' + customize.bannerText.split('\n').join('</p><p>') + '</p>'
                result = result.replace(/\*\*.+?\*\*/g, substring => {
                    return '<strong>' + substring.slice(2, substring.length - 2) + '</strong>'
                })
                return result
            })()
        } catch (e) {
            this.receive.result.failedType = 2
            Toast.clear()
            return
        }

        Toast.clear()
    },
    methods: {}
}
</script>
